const GRANULAR_ENV = {
  home: 'REACT_APP_SIMIMOVIES_ADS_HOME',
  search: 'REACT_APP_SIMIMOVIES_ADS_SEARCH',
  'media-detail': 'REACT_APP_SIMIMOVIES_ADS_MEDIA_DETAIL',
  similar: 'REACT_APP_SIMIMOVIES_ADS_SIMILAR',
  'similar-browse': 'REACT_APP_SIMIMOVIES_ADS_SIMILAR_BROWSE',
  explore: 'REACT_APP_SIMIMOVIES_ADS_EXPLORE',
  categories: 'REACT_APP_SIMIMOVIES_ADS_CATEGORIES',
  compare: 'REACT_APP_SIMIMOVIES_ADS_COMPARE',
  faq: 'REACT_APP_SIMIMOVIES_ADS_FAQ',
  'top-sites': 'REACT_APP_SIMIMOVIES_ADS_TOP',
  about: 'REACT_APP_SIMIMOVIES_ADS_ABOUT',
  contact: 'REACT_APP_SIMIMOVIES_ADS_CONTACT',
  legal: 'REACT_APP_SIMIMOVIES_ADS_LEGAL',
};

/**
 * @param {boolean} adSurfaceEnabled - from Redux: static OR managed server flag
 */
export function adSlotVisibleGranular(pageKey, adSurfaceEnabled) {
  if (!adSurfaceEnabled) return false;
  if (!pageKey) return true;
  const envName = GRANULAR_ENV[pageKey];
  if (!envName) return true;
  const v = process.env[envName];
  if (v === '0' || v === 'false') return false;
  return true;
}
